interface Props {
    children: React.ReactElement[]
}
export function NoteReplyList({ children }: Props) {
    return (
        <div data-testid="note-reply-list" className="notes-reply">
            {children}
        </div>
    )
}